import { render, staticRenderFns } from "./GStarHalfInspector.vue?vue&type=template&id=07f49902&"
import script from "./GStarHalfInspector.vue?vue&type=script&lang=js&"
export * from "./GStarHalfInspector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports